import type { AdNetworkSignalEventDto } from "app/pages/sales-intelligence/sub-modules/account-overview/company/types/signals";
import AdNetworkSignalEvent from "app/pages/sales-intelligence/sub-modules/signals/models/ad-network/AdNetworkSignalEvent";

export const getAdNetworkSignalEventActionText = (signal: AdNetworkSignalEventDto, companyName: string): string => {
    const { changeType } = signal;

    const actionText =
        changeType === AdNetworkSignalEvent.StartedWorkingWith ? "started to work with" : "stopped working with";
    return `${companyName} ${actionText}`;
};
